import { lineStrings } from 'constants/strings'
import { ELineChannelStatus, ELineWebhookStatus } from 'types'

export const getStatusLabel = (status: ELineChannelStatus) => {
  switch (status) {
    case ELineChannelStatus.ACTIVE:
      return lineStrings.edit.statusOptions.active
    case ELineChannelStatus.PAUSED:
      return lineStrings.edit.statusOptions.paused
    case ELineChannelStatus.FULL:
      return lineStrings.edit.statusOptions.full
    case ELineChannelStatus.UNLINKED:
      return lineStrings.edit.statusOptions.unlinked
    default:
      return status
  }
}

export const getWebhookStatusLabel = (status: ELineWebhookStatus) => {
  switch (status) {
    case ELineWebhookStatus.VERIFIED:
      return lineStrings.edit.webhookStatusLabels.verified
    case ELineWebhookStatus.INVALID:
      return lineStrings.edit.webhookStatusLabels.invalid
    case ELineWebhookStatus.UNVERIFIED:
    default:
      return lineStrings.edit.webhookStatusLabels.unverified
  }
}

export const getWebhookStatusStyle = (status: ELineWebhookStatus) => {
  switch (status) {
    case ELineWebhookStatus.VERIFIED:
      return 'bg-green-100 text-green-800'
    case ELineWebhookStatus.INVALID:
      return 'bg-red-100 text-red-800'
    case ELineWebhookStatus.UNVERIFIED:
    default:
      return 'bg-gray-100 text-gray-800'
  }
}
